import {
    FETCH_AGENT_SERVICES_REQUEST,
    FETCH_AGENT_SERVICES_SUCCESS,
    FETCH_AGENT_SERVICES_FAILURE,

    CREATE_AGENT_SERVICE_REQUEST,
    CREATE_AGENT_SERVICE_SUCCESS,
    CREATE_AGENT_SERVICE_FAILURE,

    UPDATE_AGENT_SERVICE_REQUEST,
    UPDATE_AGENT_SERVICE_SUCCESS,
    UPDATE_AGENT_SERVICE_FAILURE,

    DELETE_AGENT_SERVICE_REQUEST,
    DELETE_AGENT_SERVICE_SUCCESS,
    DELETE_AGENT_SERVICE_FAILURE,
} from "./types";


import {
    fetchAgentServices,
    createAgentService,
    updateAgentService,
    deleteAgentService,
} from "../../services/agentServiceService";



export const fetchAgentServicesRequest = () => ({
    type:
        FETCH_AGENT_SERVICES_REQUEST,
});



export const fetchAgentServicesSuccess = (
    services
) => ({
    type:
        FETCH_AGENT_SERVICES_SUCCESS,

    payload:
        services,
});



export const fetchAgentServicesFailure = (
    error
) => ({
    type:
        FETCH_AGENT_SERVICES_FAILURE,

    payload:
        error,
});



export const createAgentServiceRequest = () => ({
    type:
        CREATE_AGENT_SERVICE_REQUEST,
});


export const createAgentServiceSuccess = (
    service
) => ({
    type:
        CREATE_AGENT_SERVICE_SUCCESS,

    payload:
        service,
});



export const createAgentServiceFailure = (
    error
) => ({
    type:
        CREATE_AGENT_SERVICE_FAILURE,

    payload:
        error,
});



export const updateAgentServiceRequest = () => ({
    type:
        UPDATE_AGENT_SERVICE_REQUEST,
});



export const updateAgentServiceSuccess = (
    service
) => ({
    type:
        UPDATE_AGENT_SERVICE_SUCCESS,

    payload:
        service,
});



export const updateAgentServiceFailure = (
    error
) => ({
    type:
        UPDATE_AGENT_SERVICE_FAILURE,

    payload:
        error,
});



export const deleteAgentServiceRequest = () => ({
    type:
        DELETE_AGENT_SERVICE_REQUEST,
});



export const deleteAgentServiceSuccess = (
    serviceId
) => ({
    type:
        DELETE_AGENT_SERVICE_SUCCESS,

    payload:
        serviceId,
});



export const deleteAgentServiceFailure = (
    error
) => ({
    type:
        DELETE_AGENT_SERVICE_FAILURE,

    payload:
        error,
});



export const fetchAgentServicesAction =
    () => async (dispatch) => {

        dispatch(
            fetchAgentServicesRequest()
        );

        try {

            const response =
                await fetchAgentServices();

            if (response.success) {

                dispatch(
                    fetchAgentServicesSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                fetchAgentServicesFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to fetch agent services";


            dispatch(
                fetchAgentServicesFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };



export const createAgentServiceAction =
    (payload) => async (dispatch) => {

        dispatch(
            createAgentServiceRequest()
        );

        try {

            const response =
                await createAgentService(
                    payload
                );

            if (response.success) {

                dispatch(
                    createAgentServiceSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                createAgentServiceFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to create agent service";


            dispatch(
                createAgentServiceFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };



export const updateAgentServiceAction =
    (
        serviceId,
        payload
    ) => async (dispatch) => {

        dispatch(
            updateAgentServiceRequest()
        );

        try {

            const response =
                await updateAgentService(
                    serviceId,
                    payload
                );

            if (response.success) {

                dispatch(
                    updateAgentServiceSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                updateAgentServiceFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to update agent service";


            dispatch(
                updateAgentServiceFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };


export const deleteAgentServiceAction =
    (serviceId) => async (dispatch) => {

        dispatch(
            deleteAgentServiceRequest()
        );

        try {

            const response =
                await deleteAgentService(
                    serviceId
                );

            if (response.success) {

                dispatch(
                    deleteAgentServiceSuccess(
                        serviceId
                    )
                );

                return {
                    success: true,
                    data: response.data,
                    message:
                        response.message,
                };

            }

            dispatch(
                deleteAgentServiceFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to delete agent service";


            dispatch(
                deleteAgentServiceFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };